<div mat-dialog-content class="customModal dynamicModal" [ngClass]="data.customCssClass">
    <div class="flex row space-between" *ngIf="data.showIconClose">
        <h2 mat-dialog-title class="tituloDialog">{{data.title}}</h2>
        <mm-icon-button matDatepickerToggleIcon [srcIcon]="'./assetsArq/img/icons/close_grey.svg'"
        mat-dialog-close></mm-icon-button>
    </div>
    <div class="flex column align-center gap40">
      <div class="flex column align-center gap32 w-100">
        <ng-container *ngTemplateOutlet="data.template"></ng-container>
      </div>
      <div class="flex row gap24" *ngIf="data.showButtons">
        <mm-button [label]="data.labelButton1" [disabledButton]="data.disableButton1()"
          [cssClass]="data.disableButton1() ? 'secundario disabled' : data.cssBoton1"
          (notifyClick)="notificarClick1()"></mm-button>
        <mm-button [label]="data.labelButton2" [disabledButton]="data.disableButton2()"
          [cssClass]="data.disableButton2() ? 'primario disabled' : data.cssBoton2"
          (notifyClick)="notificarClick2()"></mm-button>
      </div>
    </div>
</div>